import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { HttpClientCall2j6myj8ctykar as HttpClientCall } from './HttpClientCall.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { HttpRequest3fsc4149kgwfg as HttpRequest } from '../request/HttpRequest.mjs';
import { HttpResponse1532ob1hsse1y as HttpResponse } from '../statement/HttpResponse.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function replaceResponse(_this__u8e3s4, headers, content) {
  headers = headers === VOID ? _this__u8e3s4.a5k().e55() : headers;
  return DelegatedCall().w5l(_this__u8e3s4.v5j_1, _this__u8e3s4, content, headers);
}
var DelegatedCallClass;
function DelegatedCall() {
  if (DelegatedCallClass === VOID) {
    class $ extends HttpClientCall() {
      constructor(client, originCall, responseContent, responseHeaders) {
        return new.target.w5l(client, originCall, responseContent, responseHeaders);
      }
      static w5l(client, originCall, responseContent, responseHeaders) {
        responseHeaders = responseHeaders === VOID ? originCall.a5k().e55() : responseHeaders;
        var $this = this.x5l(client);
        $this.x5j_1 = new (DelegatedRequest())($this, originCall.y5l());
        $this.y5j_1 = new (DelegatedResponse())($this, originCall.a5k(), responseContent, responseHeaders);
        return $this;
      }
    }
    initMetadataForClass($, 'DelegatedCall', VOID, VOID, VOID, [0, 1]);
    DelegatedCallClass = $;
  }
  return DelegatedCallClass;
}
var DelegatedRequestClass;
function DelegatedRequest() {
  if (DelegatedRequestClass === VOID) {
    class $ {
      constructor(call, origin) {
        this.d5m_1 = origin;
        this.e5m_1 = call;
      }
      f5m() {
        return this.e5m_1;
      }
      ww() {
        return this.d5m_1.ww();
      }
      g5m() {
        return this.d5m_1.g5m();
      }
      h5m() {
        return this.d5m_1.h5m();
      }
      z5l() {
        return this.d5m_1.z5l();
      }
      y2q() {
        return this.d5m_1.y2q();
      }
      e55() {
        return this.d5m_1.e55();
      }
    }
    initMetadataForClass($, 'DelegatedRequest', VOID, VOID, [HttpRequest()]);
    DelegatedRequestClass = $;
  }
  return DelegatedRequestClass;
}
var DelegatedResponseClass;
function DelegatedResponse() {
  if (DelegatedResponseClass === VOID) {
    class $ extends HttpResponse() {
      constructor(call, origin, content, headers) {
        headers = headers === VOID ? origin.e55() : headers;
        super();
        this.i5m_1 = call;
        this.j5m_1 = origin;
        this.k5m_1 = content;
        this.l5m_1 = headers;
        this.m5m_1 = this.j5m_1.ww();
      }
      f5m() {
        return this.i5m_1;
      }
      e55() {
        return this.l5m_1;
      }
      n5m() {
        return this.k5m_1(this.j5m_1);
      }
      ww() {
        return this.m5m_1;
      }
      o5m() {
        return this.j5m_1.o5m();
      }
      p5m() {
        return this.j5m_1.p5m();
      }
      q5m() {
        return this.j5m_1.q5m();
      }
      r5m() {
        return this.j5m_1.r5m();
      }
    }
    initMetadataForClass($, 'DelegatedResponse');
    DelegatedResponseClass = $;
  }
  return DelegatedResponseClass;
}
function resolveOrigin(_this__u8e3s4) {
  var $this = _this__u8e3s4;
  $l$1: do {
    $l$0: do {
      var tmp;
      if ($this instanceof DelegatedResponse()) {
        $this = $this.j5m_1;
        continue $l$0;
      } else {
        tmp = $this;
      }
      return tmp;
    }
     while (false);
  }
   while (true);
}
//region block: exports
export {
  replaceResponse as replaceResponse3ut5eo3odxj99,
  resolveOrigin as resolveOriginxsq87mgr6jqi,
};
//endregion

//# sourceMappingURL=DelegatedCall.mjs.map
